import React from 'react';
import { Button } from 'antd';
import { SvgIconText } from 'freesia-ui';

import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";


export default class ObjectEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    append() {
        this.props.propertyGrid.append(this.props.source, this.props.source.value);
    }

    render() {

        let title = this.props.source.value && this.props.source.value.toString();
        let tip = title;
        let btnHeight = 32;
        if (title && title.svg && title.text && title.description) {
            tip = title.text + " - " + title.description;
            btnHeight = "auto";
            title = (
                <div className="layout-h fill w0 center" title={title.text}>
                    <SvgIconText type={title.svg} size="lg" />
                    <div className="layout-v sp-left-md fill w0">
                        <div className="name-text primary-text text-nowrap">{title.text}</div>
                        <div className="description-text text-nowrap">{title.description}</div>
                    </div>
                </div>
            );
        }
        else if (title && title.svg && title.text) {
            tip = title.text;
            title = (
                <div className="layout-h fill w0 center" title={title.text}>
                    <SvgIconText type={title.svg} />
                    <div className="sp-left-md fill w0 text-nowrap">{title.text}</div>
                </div>
            );
        }
        else if (title && title.element && title.text) {
            tip = title.text;
            title = title.element;
        }
        else {
            tip = title + "";
            title = <div title={title} className="fill w0 text-nowrap">{title}</div>
        }

        return (
            <div className="hstretch" style={{ display: 'inline-block' }}>
                <Button className="hstretch fill layout-h" title={tip} onClick={e => this.append(e)} style={{ padding: "5px 7px 5px 7px", textAlign: "left", height: btnHeight, boxShadow: 'unset' }}>
                    <div className={"layout-h fill w0 text-nowrap "}>{title}</div>
                </Button>
            </div>

        );
    }
}

PropertyGridUtils.register("object", (source, propertyGrid) => <ObjectEditor source={source} propertyGrid={propertyGrid} />);